export var updateMediaSession = (player) => {
    if ('mediaSession' in navigator) {
        navigator.mediaSession.metadata = new window.MediaMetadata({
            title: player.titleToDisplay, artist: player.authorToDisplay, // gif not supported ｡ﾟ･（>﹏<）･ﾟ｡
            artwork: [{
                sizes: "246x246", src: player.imageToDisplay, type: "image/png"
            }]
        });

        navigator.mediaSession.setActionHandler('play', function () {
            // /!\ Not real play like handlePlay function /!\
            player.player.player.player.player.play();
            player.setState({playing: true});
            navigator.mediaSession.playbackState = "playing";
        });
        navigator.mediaSession.setActionHandler('pause', function () {
            // /!\ Not real pause like handlePause function /!\
            player.player.player.player.player.pause();
            player.setState({playing: false});
            navigator.mediaSession.playbackState = "paused";
        });
    }
}
